import { useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Dna, Plus, Trash2, DollarSign, Mail, User, CreditCard, Check, AlertCircle, ChevronDown, Search, ChevronLeft, ChevronRight } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Mystery dog graphic
const MYSTERY_DOG_GRAPHIC = "https://customer-assets.emergentagent.com/job_eyeblind-v2/artifacts/v369jn2e_ChatGPT%20Image%20Jun%2026%2C%202026%2C%2005_58_27%20PM.png";

// Prize image
const PRIZE_IMAGE = "https://customer-assets.emergentagent.com/job_eyeblind-v2/artifacts/lfnwkn4a_0000.png";

// All puppy images combined
const ALL_PUPPY_IMAGES = [
  "https://customer-assets.emergentagent.com/job_eyeblind-v2/artifacts/t6w8pkng_PXL_20260619_001018379.jpg",
  "https://customer-assets.emergentagent.com/job_eyeblind-v2/artifacts/6s3a3drx_1000043012.jpeg",
  "https://customer-assets.emergentagent.com/job_eyeblind-v2/artifacts/x9e85sym_1000043363.jpeg",
  "https://customer-assets.emergentagent.com/job_eyeblind-v2/artifacts/4ls3jn9z_PXL_20260619_004238943.PORTRAIT.jpg",
  "https://customer-assets.emergentagent.com/job_eyeblind-v2/artifacts/1fnw77cd_PXL_20260619_004129623.jpg",
  "https://customer-assets.emergentagent.com/job_eyeblind-v2/artifacts/5n7rx8h9_PXL_20260619_004538631.PORTRAIT.jpg",
  "https://customer-assets.emergentagent.com/job_eyeblind-v2/artifacts/gpu5h5xo_PXL_20260622_040637761.jpg"
];

// Full breed list from Embark
const BREED_LIST = [
  "Affenpinscher", "Afghan Hound", "Afghani and Pakistani Village Dog", "Airedale Terrier", "Akita", "Akita Inu",
  "Alaskan Klee Kai", "Alaskan Malamute", "Alaskan-type Husky", "Alapaha Blue Blood Bulldog", "American Bulldog",
  "American Bully", "American English Coonhound", "American Eskimo Dog", "American Foxhound", "American Hairless Terrier",
  "American Leopard Hound", "American Pit Bull Terrier", "American Samoan Village Dog", "American Staffordshire Terrier",
  "American Water Spaniel", "Anatolian Shepherd Dog", "Anguillan Village Dog", "Antiguan and Barbudan Village Dog",
  "Appenzeller Sennenhund", "Armenian Gampr", "Aruban Village Dog", "Australian Cattle Dog", "Australian Kelpie",
  "Australian Shepherd", "Australian Terrier", "Azawakh", "Bahamian Village Dog", "Bahraini Village Dog",
  "Bajan Village Dog", "Barbado da Terceira", "Barbet", "Basenji", "Basset Fauve de Bretagne", "Basset Hound",
  "Bavarian Mountain Scent Hound", "Beagle", "Bearded Collie", "Beauceron", "Bedlington Terrier", "Belgian Laekenois",
  "Belgian Malinois", "Belgian Sheepdog", "Belgian Tervuren", "Belizean Village Dog", "Bergamasco Sheepdog",
  "Berger Picard", "Bernese Mountain Dog", "Bichon Frise", "Biewer Terrier", "Black and Tan Coonhound",
  "Black Mouth Cur", "Black Russian Terrier", "Bloodhound", "Blue Lacy", "Blue Picardy Spaniel", "Bluetick Coonhound",
  "Boerboel", "Bohemian Shepherd", "Bolognese", "Border Collie", "Border Terrier", "Borzoi", "Boston Terrier",
  "Bouvier des Flandres", "Boxer", "Boykin Spaniel", "Bracco Italiano", "Braque D'Auvergne", "Braque Du Bourbonnais",
  "Braque Francais Pyrenean", "Briard", "British Virgin Islander Village Dog", "Brittany", "Broholmer",
  "Brussels Griffon", "Bull Terrier", "Bulldog", "Bullmastiff", "Caicos Islander Village Dog", "Cairn Terrier",
  "Canaan Dog", "Canadian Eskimo Dog", "Cane Corso", "Cane Di Fonni", "Cardigan Welsh Corgi", "Carolina Dog",
  "Catahoula Leopard Dog", "Caucasian Ovcharka", "Cavalier King Charles Spaniel", "Central African Village Dog",
  "Central American Village Dog", "Central Asian Shepherd Dog", "Central Asian Village Dog", "Cesky Fousek",
  "Cesky Terrier", "Chesapeake Bay Retriever", "Chihuahua", "Chinese Chongqing Dog", "Chinese Crested",
  "Chinese Shar-Pei", "Chinese Village Dog", "Chinook", "Chow Chow", "Cimarron Uruguayo", "Cirneco Dell'Etna",
  "Clumber Spaniel", "Cocker Spaniel", "Collie", "Collie (Scottish-Type)", "Colombian Fino Hound",
  "Colombian Village Dog", "Costa Rican Village Dog", "Coton de Tulear", "Coyote", "Croatian Sheepdog",
  "Cuban Village Dog", "Curly-Coated Retriever", "Czechoslovakian Vlcak", "Dachshund", "Dalmatian",
  "Dandie Dinmont Terrier", "Danish-Swedish Farmdog", "Dingo", "Djiboutian Village Dog", "Doberman Pinscher",
  "Dogo Argentino", "Dogue de Bordeaux", "Dominican Republican Village Dog", "Dominican Village Dog",
  "Drentsche Patrijshond", "Dutch Shepherd", "East Siberian Laika", "Ecuadorian Village Dog", "Egyptian Village Dog",
  "Emirati Village Dog", "English Cocker Spaniel", "English Foxhound", "English Setter", "English Shepherd",
  "English Springer Spaniel", "English Toy Spaniel", "Entlebucher Mountain Dog", "Epagneul de Pont-Audemer",
  "Estrela Mountain Dog", "Eurasier", "Field Spaniel", "Fijian Village Dog", "Fila Brasileiro", "Finnish Lapphund",
  "Finnish Spitz", "Flat-Coated Retriever", "Formosan Mountain Dog", "French Bulldog", "French Spaniel",
  "German Longhaired Pointer", "German Pinscher", "German Shepherd Dog", "German Shorthaired Pointer",
  "German Spitz", "German Wirehaired Pointer", "Giant Schnauzer", "Glen of Imaal Terrier", "Golden Retriever",
  "Gordon Setter", "Grand Basset Griffon Vendeen", "Gray Wolf", "Great Dane", "Great Pyrenees",
  "Greater Swiss Mountain Dog", "Greek Village Dog", "Greenland Dog", "Grenadian Village Dog", "Greyhound",
  "Hamiltonstovare", "Harrier", "Havanese", "Ibizan Hound", "Icelandic Sheepdog", "Irish Red and White Setter",
  "Irish Setter", "Irish Terrier", "Irish Water Spaniel", "Irish Wolfhound", "Italian Greyhound",
  "Jamaican Village Dog", "Japanese Chin", "Japanese Spitz", "Jindo", "Kai Ken", "Karakachan", "Karelian Bear Dog",
  "Keeshond", "Kerry Blue Terrier", "Kishu Ken", "Komondor", "Koolie", "Korean Village Dog", "Kromfohrlander",
  "Kuvasz", "Kuwaiti Village Dog", "Labrador Retriever", "Lagotto Romagnolo", "Lakeland Terrier",
  "Lancashire Heeler", "Lapponian Herder", "Leonberger", "Lhasa Apso", "Llewellin Setter", "Lowchen",
  "Maltese", "Manchester Terrier (Standard)", "Manchester Terrier (Toy)", "Maremma Sheepdog", "Markiesje",
  "Mastiff", "McNab", "Mexican Village Dog", "Mi-Ki", "Miniature/MAS-type Australian Shepherd",
  "Miniature Bull Terrier", "Miniature Pinscher", "Miniature Schnauzer", "Mountain Cur", "Mudi",
  "Munsterlander (Large)", "Munsterlander (Small)", "Murray River Retriever", "Neapolitan Mastiff",
  "Nederlandse Kooikerhondje", "New Guinea Singing Dog", "New Zealand Huntaway", "Newfoundland",
  "Norfolk Terrier", "Norrbottenspets", "Norwegian Buhund", "Norwegian Elkhound", "Norwegian Lundehund",
  "Norwich Terrier", "Nova Scotia Duck Tolling Retriever", "Old Danish Pointing Dog", "Old English Sheepdog",
  "Olde English Bulldogge", "Omani Village Dog", "Otterhound", "Panamanian Village Dog", "Papillon",
  "Papuan Village Dog", "Pekingese", "Pembroke Welsh Corgi", "Perdiguero de Burgos", "Perro de Presa Canario",
  "Peruvian Inca Orchid", "Peruvian Village Dog", "Petit Basset Griffon Vendeen", "Pharaoh Hound",
  "Filipino Village Dog", "Phu Quoc Ridgeback", "Picardy Spaniel", "Plott", "Pointer", "Polish Lowland Sheepdog",
  "Polish Tatra Sheepdog", "Pomeranian", "Poodle (Small)", "Poodle (Standard)", "Portuguese Podengo",
  "Portuguese Podengo Pequeno", "Portuguese Pointer", "Portuguese Sheepdog", "Portuguese Water Dog",
  "Prague Ratter", "Pudelpointer", "Puerto Rican Village Dog", "Pug", "Puli", "Pumi", "Pungsan",
  "Pyrenean Mastiff", "Pyrenean Shepherd", "Qatari Village Dog", "Rat Terrier", "Redbone Coonhound",
  "Rhodesian Ridgeback", "Romanian Mioritic Shepherd Dog", "Romanian Village Dog", "Rottweiler",
  "Russell-type Terrier", "Russian Toy", "Russian Tsvetnaya Bolonka", "Russian Village Dog", "Saarloos Wolfdog",
  "Saint Bernard", "Saluki", "Samoyed", "Sarplaninac", "Schapendoes", "Schipperke", "Scottish Deerhound",
  "Scottish Terrier", "Sealyham Terrier", "Shetland Sheepdog", "Shiba Inu", "Shih Tzu", "Shikoku",
  "Shiloh Shepherd", "Siberian Husky", "Silken Windhound", "Silky Terrier", "Singaporean Village Dog",
  "Skye Terrier", "Sloughi", "Slovensky Cuvac", "Smooth Fox Terrier", "Soft Coated Wheaten Terrier",
  "Solomon Islander Village Dog", "South Asian Village Dog", "Southeast Asian Village Dog", "Spanish Galgo",
  "Spanish Mastiff", "Spanish Water Dog", "Spinone Italiano", "Stabyhoun", "Staffordshire Bull Terrier",
  "Standard Schnauzer", "Sussex Spaniel", "Swedish Lapphund", "Swedish Vallhund", "Teddy Roosevelt Terrier",
  "Terrier Brasileiro", "Thai Bangkaew", "Thai Ridgeback", "Tibetan Mastiff", "Tibetan Spaniel",
  "Tibetan Terrier", "Tornjak", "Tosa (Inu)", "Toy Fox Terrier", "Treeing Walker Coonhound",
  "Trinidadian and Tobagonian Village Dog", "Vizsla", "Volpino Italiano", "Weimaraner", "Welsh Sheepdog",
  "Welsh Springer Spaniel", "Welsh Terrier", "West African Village Dog", "West Asian Village Dog",
  "West Highland White Terrier", "West Siberian Laika", "Western European Village Dog", "Wetterhoun",
  "Whippet", "White Shepherd", "Windsprite", "Wire Fox Terrier", "Wirehaired Pointing Griffon",
  "Wirehaired Vizsla", "Xigou", "Xoloitzcuintli", "Yakutian Laika", "Yorkshire Terrier", "Yucatan Village Dog"
].sort();

const PAYMENT_METHODS = [
  { id: "card", name: "Credit/Debit Card" },
  { id: "paypal", name: "PayPal" },
  { id: "venmo", name: "Venmo (@3eyeblind)" },
  { id: "zelle", name: "Zelle" }
];

const Contest = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [guesses, setGuesses] = useState([{ breed: "", percentage: "" }]);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeDropdown, setActiveDropdown] = useState(null);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % ALL_PUPPY_IMAGES.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + ALL_PUPPY_IMAGES.length) % ALL_PUPPY_IMAGES.length);
  };

  const totalPercentage = useMemo(() => {
    return guesses.reduce((sum, g) => sum + (parseFloat(g.percentage) || 0), 0);
  }, [guesses]);

  const filteredBreeds = useMemo(() => {
    if (!searchTerm) return BREED_LIST;
    const term = searchTerm.toLowerCase();
    return BREED_LIST.filter(breed => 
      breed.toLowerCase().includes(term)
    );
  }, [searchTerm]);

  const addGuess = () => {
    setGuesses([...guesses, { breed: "", percentage: "" }]);
  };

  const removeGuess = (index) => {
    if (guesses.length > 1) {
      setGuesses(guesses.filter((_, i) => i !== index));
    }
  };

  const updateGuess = (index, field, value) => {
    const newGuesses = [...guesses];
    newGuesses[index][field] = value;
    setGuesses(newGuesses);
  };

  const selectBreed = (index, breed) => {
    updateGuess(index, "breed", breed);
    setActiveDropdown(null);
    setSearchTerm("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name || !email) {
      toast.error("Please enter your name and email");
      return;
    }
    
    if (!paymentMethod) {
      toast.error("Please select a payment method");
      return;
    }
    
    const validGuesses = guesses.filter(g => g.breed && g.percentage);
    if (validGuesses.length === 0) {
      toast.error("Please add at least one breed guess");
      return;
    }
    
    if (Math.abs(totalPercentage - 100) > 0.01) {
      toast.error(`Percentages must total 100%. Current total: ${totalPercentage}%`);
      return;
    }

    try {
      setSubmitting(true);
      await axios.post(`${BACKEND_URL}/api/contest/entries`, {
        name,
        email,
        payment_method: paymentMethod,
        puppy: "dottie",
        guesses: validGuesses.map(g => ({
          breed: g.breed,
          percentage: parseFloat(g.percentage)
        }))
      });
      
      setSubmitted(true);
      toast.success("Entry submitted! Please complete your $5 payment.");
    } catch (err) {
      const errorMsg = err.response?.data?.error || "Error submitting entry";
      toast.error(errorMsg);
    } finally {
      setSubmitting(false);
    }
  };

  const resetForm = () => {
    setName("");
    setEmail("");
    setPaymentMethod("");
    setGuesses([{ breed: "", percentage: "" }]);
    setSubmitted(false);
  };

  return (
    <div className="min-h-screen bg-[#0D0D0B] pt-20">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-b from-[#1A1C18] to-[#0D0D0B] border-b border-[#4A5320]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            {/* Mystery Dog Graphic */}
            <motion.img
              src={MYSTERY_DOG_GRAPHIC}
              alt="Mystery Dog"
              className="w-48 h-48 md:w-64 md:h-64 mx-auto mb-6 object-contain"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2 }}
            />
            
            <span className="font-mono text-[#FFD700] text-sm uppercase tracking-widest mb-4 block">
              Fundraiser Contest
            </span>
            <h1 className="font-['Bebas_Neue'] text-5xl md:text-7xl text-white mb-6">
              Guess the Breed!
            </h1>
            <div className="flex items-center justify-center gap-2 mb-6">
              <Dna className="w-6 h-6 text-[#FFD700]" />
              <span className="text-[#A3A3A3] text-lg">Embark DNA Test Challenge</span>
            </div>
            <p className="text-[#A3A3A3] text-lg max-w-3xl mx-auto mb-4">
              Meet <span className="text-[#FFD700] font-semibold">Dottie</span> and <span className="text-[#FFD700] font-semibold">Kit</span> - two surprise puppies born to Lena, 
              a dog we rescued from a terrible hoarding situation. She was so skinny we had no idea 
              she was pregnant until she began giving birth!
            </p>
            <p className="text-[#A3A3A3] text-lg max-w-3xl mx-auto mb-4">
              We&apos;re running an <span className="text-white font-semibold">Embark DNA test on Dottie</span> to find out what breeds make up these adorable pups. 
              Can you guess her breed mix?
            </p>
            <p className="text-white text-xl font-semibold">
              <span className="text-[#FFD700]">$5</span> per entry - Help us while having fun!
            </p>
          </motion.div>
        </div>
      </section>

      {/* Prize Section */}
      <section className="py-12 bg-[#0D0D0B]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="card-tactical p-8"
          >
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-shrink-0">
                <img 
                  src={PRIZE_IMAGE} 
                  alt="Prize - Dog Wine Bottle Holder" 
                  className="w-48 h-48 md:w-64 md:h-64 object-contain rounded-lg"
                />
              </div>
              <div className="text-center md:text-left">
                <span className="font-mono text-[#FFD700] text-sm uppercase tracking-widest mb-2 block">
                  Winner&apos;s Prize
                </span>
                <h3 className="font-['Bebas_Neue'] text-4xl text-white mb-4">
                  Dog Wine Bottle Holder
                </h3>
                <p className="text-[#A3A3A3] text-lg">
                  The person who guesses closest to Dottie&apos;s actual breed percentages wins an adorable 
                  dog-shaped wine bottle holder!
                </p>
                <p className="text-[#666] text-sm mt-2 italic">
                  (Wine not included. Image is preview rendering of custom holder. Final product may vary.)
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Puppy Photos Gallery */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-['Bebas_Neue'] text-3xl text-white text-center mb-8">
            Meet The Mystery Pups
          </h2>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="card-tactical p-6"
          >
            {/* Main Image Display */}
            <div className="relative mb-4">
              <div className="aspect-square md:aspect-[4/3] overflow-hidden rounded border-2 border-[#4A5320] bg-[#0A0A0A]">
                <AnimatePresence mode="wait">
                  <motion.img
                    key={currentImageIndex}
                    src={ALL_PUPPY_IMAGES[currentImageIndex]}
                    alt={`Dottie and Kit ${currentImageIndex + 1}`}
                    className="w-full h-full object-contain"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  />
                </AnimatePresence>
              </div>
              
              {/* Navigation Arrows */}
              <button
                onClick={prevImage}
                className="absolute left-2 top-1/2 -translate-y-1/2 w-12 h-12 bg-black/70 hover:bg-black/90 border border-[#4A5320] hover:border-[#FFD700] text-white flex items-center justify-center transition-all"
                aria-label="Previous image"
              >
                <ChevronLeft className="w-6 h-6" />
              </button>
              <button
                onClick={nextImage}
                className="absolute right-2 top-1/2 -translate-y-1/2 w-12 h-12 bg-black/70 hover:bg-black/90 border border-[#4A5320] hover:border-[#FFD700] text-white flex items-center justify-center transition-all"
                aria-label="Next image"
              >
                <ChevronRight className="w-6 h-6" />
              </button>
              
              {/* Image Counter */}
              <div className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-black/70 px-3 py-1 rounded text-white text-sm font-mono">
                {currentImageIndex + 1} / {ALL_PUPPY_IMAGES.length}
              </div>
            </div>

            {/* Thumbnail Strip */}
            <div className="flex gap-2 overflow-x-auto pb-2">
              {ALL_PUPPY_IMAGES.map((img, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentImageIndex(idx)}
                  className={`flex-shrink-0 w-16 h-16 md:w-20 md:h-20 overflow-hidden rounded border-2 transition-all ${
                    currentImageIndex === idx
                      ? "border-[#FFD700] ring-2 ring-[#FFD700]/50"
                      : "border-[#4A5320] hover:border-[#666] opacity-60 hover:opacity-100"
                  }`}
                >
                  <img
                    src={img}
                    alt={`Thumbnail ${idx + 1}`}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>

            <p className="text-[#A3A3A3] text-sm text-center mt-4">
              Dottie & Kit - Can you guess what breeds make up these adorable pups?
            </p>
          </motion.div>
        </div>
      </section>

      {/* Entry Form */}
      <section className="py-16 bg-[#1A1C18]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-['Bebas_Neue'] text-4xl text-white text-center mb-2">
              Submit Your Guess
            </h2>
            <p className="text-[#A3A3A3] text-center mb-8">
              Each entry is $5. You can submit multiple entries!
            </p>

            {submitted ? (
              /* Success State */
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="card-tactical p-8 text-center"
              >
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Check className="w-8 h-8 text-white" />
                </div>
                <h3 className="font-['Bebas_Neue'] text-3xl text-[#FFD700] mb-4">
                  Entry Submitted!
                </h3>
                <p className="text-[#A3A3A3] mb-6">
                  Thank you for guessing Dottie&apos;s breed mix! Please complete your <span className="text-[#FFD700] font-semibold">$5 payment</span> using one of the methods below:
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                  <a
                    href="https://www.paypal.com/donate/?hosted_button_id=SPQN8WSG432Q4"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-4 border border-[#4A5320] hover:border-[#FFD700] transition-colors text-center"
                  >
                    <span className="text-white font-semibold">PayPal</span>
                  </a>
                  <a
                    href="https://venmo.com/u/threeEyeBlindrescue"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-4 border border-[#4A5320] hover:border-[#FFD700] transition-colors text-center"
                  >
                    <span className="text-white font-semibold">Venmo</span>
                    <p className="text-[#666] text-xs">@threeEyeBlindrescue</p>
                  </a>
                  <a
                    href="https://www.zeffy.com/embed/donation-form/donate-to-make-a-difference-13204?modal=true"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-4 border border-[#4A5320] hover:border-[#FFD700] transition-colors text-center"
                  >
                    <span className="text-white font-semibold">Credit/Debit</span>
                    <p className="text-[#666] text-xs">via Zeffy</p>
                  </a>
                </div>
                
                <div className="p-4 bg-[#0A0A0A] border border-[#4A5320] text-center mb-6">
                  <span className="text-white font-semibold">Zelle</span>
                  <p className="text-[#A3A3A3] text-sm mt-1">
                    Send with your banking app to <span className="text-[#FFD700]">threeeyeblindrescue@gmail.com</span>
                  </p>
                </div>
                
                <p className="text-[#666] text-sm mb-6">
                  Please include &quot;Breed Contest - [Your Name]&quot; in your payment note.
                </p>
                
                <button
                  onClick={resetForm}
                  className="btn-primary"
                >
                  Submit Another Entry
                </button>
              </motion.div>
            ) : (
              /* Entry Form */
              <form onSubmit={handleSubmit} className="card-tactical p-8">
                {/* Name & Email */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  <div>
                    <label className="block text-[#A3A3A3] text-xs font-mono uppercase tracking-widest mb-2">
                      Your Name *
                    </label>
                    <div className="relative">
                      <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-[#666]" />
                      <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        className="w-full pl-10 pr-4 py-3 bg-[#0A0A0A] border border-[#4A5320] text-white focus:outline-none focus:border-[#FFD700]"
                        placeholder="Enter your name"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-[#A3A3A3] text-xs font-mono uppercase tracking-widest mb-2">
                      Email Address *
                    </label>
                    <div className="relative">
                      <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-[#666]" />
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="w-full pl-10 pr-4 py-3 bg-[#0A0A0A] border border-[#4A5320] text-white focus:outline-none focus:border-[#FFD700]"
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>
                </div>

                {/* Payment Method */}
                <div className="mb-8">
                  <label className="block text-[#A3A3A3] text-xs font-mono uppercase tracking-widest mb-2">
                    Payment Method *
                  </label>
                  <div className="grid grid-cols-2 gap-2">
                    {PAYMENT_METHODS.map((method) => (
                      <button
                        key={method.id}
                        type="button"
                        onClick={() => setPaymentMethod(method.id)}
                        className={`p-3 border text-sm transition-all ${
                          paymentMethod === method.id
                            ? "border-[#FFD700] bg-[#FFD700]/10 text-[#FFD700]"
                            : "border-[#4A5320] text-[#A3A3A3] hover:border-[#666]"
                        }`}
                      >
                        {method.name}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Breed Guesses */}
                <div className="mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <label className="block text-[#A3A3A3] text-xs font-mono uppercase tracking-widest">
                      Your Breed Guesses *
                    </label>
                    <div className={`text-sm font-mono ${
                      Math.abs(totalPercentage - 100) < 0.01 
                        ? "text-green-400" 
                        : totalPercentage > 100 
                          ? "text-red-400" 
                          : "text-[#FFD700]"
                    }`}>
                      Total: {totalPercentage}%
                      {Math.abs(totalPercentage - 100) < 0.01 && <Check className="inline w-4 h-4 ml-1" />}
                    </div>
                  </div>
                  
                  <p className="text-[#666] text-xs mb-4">
                    Select breeds and percentages that total 100%. Type to search breeds.
                    <a 
                      href="https://embarkvet.com/dog-breeds-list/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-[#FFD700] hover:text-white ml-1"
                    >
                      View all breeds on Embark →
                    </a>
                  </p>

                  <div className="space-y-3">
                    {guesses.map((guess, index) => (
                      <div key={index} className="flex gap-2 items-start">
                        {/* Breed Dropdown */}
                        <div className="flex-1 relative">
                          <div
                            onClick={() => {
                              setActiveDropdown(activeDropdown === index ? null : index);
                              setSearchTerm("");
                            }}
                            className="w-full px-4 py-3 bg-[#0A0A0A] border border-[#4A5320] text-white cursor-pointer flex items-center justify-between"
                          >
                            <span className={guess.breed ? "text-white" : "text-[#666]"}>
                              {guess.breed || "Select breed..."}
                            </span>
                            <ChevronDown className="w-4 h-4 text-[#666]" />
                          </div>
                          
                          {activeDropdown === index && (
                            <div className="absolute z-50 w-full mt-1 bg-[#1A1C18] border border-[#4A5320] max-h-60 overflow-hidden">
                              {/* Search Input */}
                              <div className="p-2 border-b border-[#4A5320]">
                                <div className="relative">
                                  <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-[#666]" />
                                  <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder="Type to search..."
                                    className="w-full pl-8 pr-2 py-2 bg-[#0A0A0A] border border-[#4A5320] text-white text-sm focus:outline-none focus:border-[#FFD700]"
                                    autoFocus
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                </div>
                              </div>
                              {/* Breed List */}
                              <div className="max-h-48 overflow-y-auto">
                                {filteredBreeds.length > 0 ? (
                                  filteredBreeds.map((breed) => (
                                    <button
                                      key={breed}
                                      type="button"
                                      onClick={() => selectBreed(index, breed)}
                                      className={`w-full px-4 py-2 text-left text-sm hover:bg-[#4A5320]/30 ${
                                        guess.breed === breed ? "bg-[#FFD700]/20 text-[#FFD700]" : "text-white"
                                      }`}
                                    >
                                      {breed}
                                    </button>
                                  ))
                                ) : (
                                  <p className="px-4 py-3 text-[#666] text-sm">No breeds found</p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Percentage Input */}
                        <div className="w-24">
                          <div className="relative">
                            <input
                              type="number"
                              min="1"
                              max="100"
                              step="0.1"
                              value={guess.percentage}
                              onChange={(e) => updateGuess(index, "percentage", e.target.value)}
                              placeholder="%"
                              className="w-full px-3 py-3 bg-[#0A0A0A] border border-[#4A5320] text-white text-center focus:outline-none focus:border-[#FFD700]"
                            />
                            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#666]">%</span>
                          </div>
                        </div>

                        {/* Remove Button */}
                        {guesses.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeGuess(index)}
                            className="p-3 text-red-400 hover:text-red-300 hover:bg-red-900/20"
                          >
                            <Trash2 className="w-5 h-5" />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>

                  <button
                    type="button"
                    onClick={addGuess}
                    className="mt-3 flex items-center gap-2 text-[#FFD700] text-sm hover:text-white transition-colors"
                  >
                    <Plus className="w-4 h-4" /> Add Another Breed
                  </button>
                </div>

                {/* Percentage Warning */}
                {totalPercentage !== 100 && totalPercentage > 0 && (
                  <div className="mb-6 p-3 bg-yellow-900/20 border border-yellow-700 flex items-center gap-2">
                    <AlertCircle className="w-5 h-5 text-yellow-500 flex-shrink-0" />
                    <p className="text-yellow-500 text-sm">
                      Percentages must total exactly 100%. Currently at {totalPercentage}%.
                    </p>
                  </div>
                )}

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={submitting || Math.abs(totalPercentage - 100) > 0.01}
                  className="w-full btn-primary py-4 text-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {submitting ? (
                    <>
                      <div className="w-5 h-5 border-2 border-black border-t-transparent rounded-full animate-spin" />
                      Submitting...
                    </>
                  ) : (
                    <>
                      <DollarSign className="w-5 h-5" />
                      Submit Entry ($5)
                    </>
                  )}
                </button>

                <p className="text-[#666] text-xs text-center mt-4">
                  Your name will not be displayed publicly. Winners will be contacted via email.
                </p>
              </form>
            )}
          </motion.div>
        </div>
      </section>

      {/* Rules Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-['Bebas_Neue'] text-3xl text-white text-center mb-8">
            Contest Rules
          </h2>
          <div className="card-tactical p-8">
            <ul className="space-y-4 text-[#A3A3A3]">
              <li className="flex items-start gap-3">
                <span className="text-[#FFD700] font-bold">1.</span>
                <span>Each entry costs <span className="text-white font-semibold">$5</span>. You can submit as many entries as you like!</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#FFD700] font-bold">2.</span>
                <span>Your breed percentages must total <span className="text-white font-semibold">exactly 100%</span>.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#FFD700] font-bold">3.</span>
                <span>You are guessing <span className="text-white font-semibold">Dottie&apos;s</span> breed mix based on her Embark DNA test.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#FFD700] font-bold">4.</span>
                <span>The winner will be the person with the closest matching percentages to the Embark DNA results.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#FFD700] font-bold">5.</span>
                <span>Winners will be announced once we receive the DNA results and will be contacted via email.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#FFD700] font-bold">6.</span>
                <span>All proceeds go directly to Three Eye Blind Animal Rescue to help our foster pets!</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contest;
